import React from 'react'
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { CircleHelp, ExternalLink, MessageSquareText } from 'lucide-react'
import Auth from '../../providers/AuthProvider'
import CurrentClientContext from '../../providers/CurrentClientProvider'
import UserService from '../../services/UserService'

const retailOrbitSupportFormUrl = 'https://www.cognitoforms.com/ManagementOne1/SERVICEREQUEST'

export function buildRetailOrbitSupportFormUrl({ user, client }) {
  const params = {}

  if (user) {
    params.Name = {
      First: user.first_name || '',
      Last: user.last_name || '',
    }
    params.EmailAddress = user.email
  }

  if (client?.ClientCode) {
    params.ClientCode = client.ClientCode
  }

  if (client?.Name) {
    params.StoreName = client.Name
  }

  return `${retailOrbitSupportFormUrl}?entry=${encodeURIComponent(JSON.stringify(params))}`
}

export default function V3HeaderHelpMenu() {
  const auth = Auth.useAuth()
  const currentClient = CurrentClientContext.useClient()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const menuOpen = Boolean(anchorEl)

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const getZendLink = async () => {
    closeMenu()
    const response = await UserService.getZendUrl()
    if (response?.url) {
      window.open(response.url, '_blank', 'location=no')
    }
  }

  const getSupportFormLink = () => {
    closeMenu()
    const url = buildRetailOrbitSupportFormUrl({
      user: auth?.user,
      client: currentClient?.client,
    })
    window.open(url, '_blank', 'location=no')
  }

  return (
    <>
      <IconButton
        aria-label="Help"
        aria-controls={menuOpen ? 'v3-help-menu' : undefined}
        aria-expanded={menuOpen ? 'true' : undefined}
        aria-haspopup="menu"
        onClick={openMenu}
        className="!h-12 !w-12 !rounded-[14px] !border !border-[#EAECF0] !bg-white !text-gray-700 transition-colors hover:!bg-gray-50"
      >
        <CircleHelp className="h-[22px] w-[22px]" strokeWidth={1.8} />
      </IconButton>

      <Menu
        id="v3-help-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              minWidth: 220,
              border: '1px solid #EAECF0',
              borderRadius: '16px',
              boxShadow: '0 16px 36px rgba(16, 24, 40, 0.12)',
              overflow: 'hidden',
            },
          },
        }}
      >
        <MenuItem onClick={getZendLink} sx={{ py: 1.25 }}>
          <ListItemIcon sx={{ minWidth: 34 }}>
            <ExternalLink size={16} color="#7F56D9" />
          </ListItemIcon>
          <ListItemText
            primary="24/7 Help Center"
            primaryTypographyProps={{ fontSize: 14, fontWeight: 500, color: '#344054' }}
          />
        </MenuItem>
        <MenuItem onClick={getSupportFormLink} sx={{ py: 1.25 }}>
          <ListItemIcon sx={{ minWidth: 34 }}>
            <MessageSquareText size={16} color="#7F56D9" />
          </ListItemIcon>
          <ListItemText
            primary="Submit a Ticket"
            primaryTypographyProps={{ fontSize: 14, fontWeight: 500, color: '#344054' }}
          />
        </MenuItem>
      </Menu>
    </>
  )
}

